import { z } from "zod";
export const Step3Schema = z.object({
  firstName: z.string().min(1, "onboarding.validation.firstNameRequired"),
  lastName: z.string().min(1, "onboarding.validation.lastNameRequired"),
  phone: z.string().min(5, "onboarding.validation.phoneInvalid"),
  email: z.string().email("onboarding.validation.emailInvalid"),
});

export type Step3Input = z.infer<typeof Step3Schema>;
